import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'
import Switch, { Case } from 'react-switch-case';
import md5 from 'js-md5';

// import other components within the same project here
import Config from "../../Config.jsx";

import Localization from "../../Localization.jsx"

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, Tabs, Tab, Icon } from '@material-ui/core';

import RootPage from "../../pages/RootPage.jsx"
import UserList from "../../views/storage/UserList.jsx"
import StorageTable from "../../views/storage/StorageTable.jsx"

const VIEW_BY_SCHOOL = 0;
const VIEW_BY_USER = 1;

class StorageViewerDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      fileSize: 0,
      fileSizePercentage: 0,

      userOption: 0,

      sortBy: "locale_size",
      sortInAsc: false,

      viewByOption: 0,
      userList: [],
      data: [],
      open: false,

      hiddenCount: 0,

      cleanedAllCount: 0,
      cleanedHiddenCount: 0,
      cleanedUnusedCount: 0,

      deletedLocaleList: [],
    };
    autoBind(this);
  }

  handleEnter() {
    if (this.props.root.getSameSchoolEdit() == 1) {
      this.getTotalLocaleSizeBySchoolId(this.props.root.getMySchoolId());
      this.getStorageInfoBySchoolId(this.props.root.getMySchoolId());
      this.getUserListBySchoolId(this.props.root.getMySchoolId());
    }
    else if (this.props.root.getSameSchoolEdit() == 0) {
      this.getTotalLocaleSizeByUserId(this.props.root.getMyUserId());
      this.getStorageInfoByUserId(this.props.root.getMyUserId());
    }
  }

  close() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleClose() {
    this.close();

    if (this.props.root.state.status == this.props.root.STATUS_VIEW_LOCALE_LIST()) {
      this.props.root.refs.localeViewerPage.refreshLocaleList();
    }

    if (this.props.root.state.status == this.props.root.STATUS_VIEW_LOCALE_STAGE()
      || this.props.root.state.status == this.props.root.STATUS_VIEW_RETRIEVER()
    ) {
      let currentLocaleID = this.props.root.state.targetLocaleData['id'];
      let currentLocaleIsDeleted = false;
      for (let i = 0; i < this.state.deletedLocaleList.length; i++) {
        if (currentLocaleID == this.state.deletedLocaleList[i]) {
          currentLocaleIsDeleted = true;
        }
      }
      if (currentLocaleIsDeleted) {
        this.props.root.changeStatus(this.props.root.STATUS_VIEW_LOCALE_LIST());
      }
    }

    this.setState({ deletedLocaleList: [] });
    this.state.deletedLocaleList = [];
  }

  changeTab(index) {
    let newIndex = this.state.viewByOption;
    if (newIndex == index) {
      return;
    }
    newIndex = index;
    this.setState({
      viewByOption: newIndex,
    });
    this.state.viewByOption = newIndex;

    this.refresh(this.state.viewByOption);
  }

  handleTabChange = (event, value) => {
    this.changeTab(value);
  }

  getTotalLocaleSizeBySchoolId(schoolId) {
    let requestObj = { school_id: schoolId };
    this.props.root.refs.API.request("get_total_locale_size_by_school_id", requestObj, this.getTotalLocaleSizeOK, this.getTotalLocaleSizeFailed);
  }

  getTotalLocaleSizeByUserId(userId) {
    let requestObj = { user_id: userId };
    this.props.root.refs.API.request("get_total_locale_size_by_user_id", requestObj, this.getTotalLocaleSizeOK, this.getTotalLocaleSizeFailed);
  }

  getTotalLocaleSizeOK(res) {
    let resultSize = res.body['result'];
    resultSize = (resultSize / (1024 * 1024 * 1024)).toFixed(2);

    this.setState({
      fileSize: resultSize,
    });
    this.state.fileSize = resultSize;
  }

  getTotalLocaleSizeFailed(err) {
    console.log("get total locale size failed");
  }

  getUserListBySchoolId(schoolId) {
    let requestObj = {school_id: schoolId};
    this.props.root.refs.API.request("get_user_data_by_school_id", requestObj, this.getUserListOK, this.getUserListFailed);
  }

  getUserListOK(res) {
    this.setState({userList: res.body['result']});
    this.state.userList = res.body['result'];
    this.setDefaultUserOption(this.props.root.getMyUserId());
  }

  getUserListFailed(err) {
    console.log("getUserListFailed");
  }

  setDefaultUserOption(userId) {
    let option = 0;

    for (var i = 0; i < this.state.userList.length; i++) {
      if (this.state.userList[i]['id'] == userId) {
        option = i;
      }
    }

    this.setState({ userOption: option });
    this.state.userOption = option;
  }

  userOptionChanged(e) {
    let index = e.target.value;
    this.setState({ userOption: index });
    this.state.userOption = index;

    let userId = this.state.userList[index]['id'];
    this.getTotalLocaleSizeByUserId(userId);
    this.getStorageInfoByUserId(userId);
  }

  getStorageInfoBySchoolId(schoolId) {
    if (this.refs.storageTable) {
      this.refs.storageTable.deselectAll();
    }
    let requestObj = { school_id: schoolId };
    this.props.root.refs.API.request("get_storage_info_by_school_id", requestObj, this.getStorageInfoOK, this.getStorageInfoFailed);
  }

  getStorageInfoByUserId(userId) {
    if (this.refs.storageTable) {
      this.refs.storageTable.deselectAll();
    }
    let requestObj = { user_id: userId };
    this.props.root.refs.API.request("get_storage_info_by_user_id", requestObj, this.getStorageInfoOK, this.getStorageInfoFailed);
  }

  getStorageInfoOK(res) {
    this.setState({ data: res.body['result'] });
    this.state.data = res.body['result'];

    this.sortData();
  }

  getStorageInfoFailed(err) {
    console.log("get storage info failed");
  }

  getAllLocaleSize() {
    let size = 0;
    for (let i = 0; i < this.state.data.length; i++) {
      size += this.state.data[i]['locale_size'];
    }
    return size;
  }

  getAllAnswerSize() {
    let size = 0;
    for (let i = 0; i < this.state.data.length; i++) {
      size += this.state.data[i]['ans_size'];
    }
    return size;
  }

  cleanAllClicked() {
    let dialogText = {
      title: "Clean up all VITALS",
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    };
    this.props.root.refs.confirmDialog.show(dialogText, this.cleanAllConfirmClicked, this.cleanCancelClicked);
  }

  cleanAllConfirmClicked() {
    let tmpList = this.state.deletedLocaleList;
    for (let i = 0; i < this.state.data.length; i++) {
      tmpList.push(this.state.data[i]['locale_id']);
    }
    this.setState({ deletedLocaleList: tmpList });

    for (let i = 0; i < this.state.data.length; i++) {
      let locale = this.state.data[i];
      let salt = Config.GET_MD5_KILL_SALT();
      let security_key = salt + locale['locale_id'] + salt;
      let requestObj = {
        locale_id: locale['locale_id'],
        security_key: md5(security_key),
      }
      this.props.root.refs.API.request("kill_locale", requestObj, this.cleanAllOK, this.cleanAllFailed);
    }
  }

  cleanAllOK(res) {
    this.setState((prevState, props) => ({
      cleanedAllCount: prevState.cleanedAllCount + 1
    }));

    if (this.state.cleanedAllCount == this.state.data.length) {
      this.reload();

      this.setState({
        cleanedAllCount: 0,
      });
      this.state.cleanedAllCount = 0;
    }
  }

  cleanAllFailed() {
    console.log("clean all failed");
  }

  cleanHiddenClicked() {
    let dialogText = {
      title: "Clean up hidden VITALs",
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    };
    this.props.root.refs.confirmDialog.show(dialogText, this.cleanHiddenConfirmClicked, this.cleanCancelClicked);
  }

  cleanHiddenConfirmClicked() {
    for (let i = 0; i < this.state.data.length; i++) {
      let data = this.state.data[i];

      if (data['is_hidden'] == 1) {
        this.setState((prevState, props) => ({
          hiddenCount: prevState.hiddenCount + 1
        }));
      }
    }

    if (this.state.hiddenCount == 0) {
      return;
    }

    for (let i = 0; i < this.state.data.length; i++) {
      let data = this.state.data[i];

      if (data['is_hidden'] == 1) {
        let salt = Config.GET_MD5_KILL_SALT();
        let security_key = salt + data['locale_id'] + salt;

        let requestObj = {};
        requestObj['locale_id'] = data['locale_id'];
        requestObj['security_key'] = md5(security_key);

        this.props.root.refs.API.request("kill_locale", requestObj, this.cleanHiddenOK, this.cleanHiddenFailed);
      }
    }
  }

  cleanHiddenOK() {
    this.setState((prevState, props) => ({
      cleanedHiddenCount: prevState.cleanedHiddenCount + 1
    }));

    if (this.state.cleanedHiddenCount == this.state.hiddenCount) {
      this.reload();

      this.setState({
        cleanedHiddenCount: 0,
        hiddenCount: 0,
      });
      this.state.cleanedHiddenCount = 0;
      this.state.hiddenCount = 0;
    }
  }

  cleanHiddenFailed(err) {
    console.log("clean hidden failed");
  }

  cleanUnusedClicked() {
    let dialogText = {
      title: "Clean up unused files",
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    };
    this.props.root.refs.confirmDialog.show(dialogText, this.cleanUnusedConfirmClicked, this.cleanCancelClicked);
  }

  cleanUnusedConfirmClicked() {
    for (let i = 0; i < this.state.data.length; i++) {
      let data = this.state.data[i];

      let requestObj = {};
      requestObj['locale_id'] = data['locale_id'];

      this.props.root.refs.API.request("clear_locale_zombie_files", requestObj, this.cleanUnusedOK, this.cleanUnusedFailed);
    }
  }

  cleanUnusedOK(res) {
    this.setState((prevState, props) => ({
      cleanedUnusedCount: prevState.cleanedUnusedCount + 1
    }));

    if (this.state.cleanedUnusedCount == this.state.data.length) {
      this.reload();

      this.setState({
        cleanedUnusedCount: 0,
      });
      this.state.cleanedUnusedCount = 0;
    }
  }

  cleanUnusedFailed(err) {
    console.log("clean unused failed");
  }

  cleanCancelClicked() {

  }

  reload() {
    this.refresh(this.state.viewByOption);
  }

  reloadSize() {
    this.refreshSize(this.state.viewByOption);
  }

  refresh(option) {
    // Normal User
    if (this.props.root.getSameSchoolEdit() <= 0) {
      this.getTotalLocaleSizeByUserId(this.props.root.getMyUserId());
      this.getStorageInfoByUserId(this.props.root.getMyUserId());
      return;
    }

    // Admin
    if (option == VIEW_BY_SCHOOL) {
      this.getTotalLocaleSizeBySchoolId(this.props.root.getMySchoolId());
      this.getStorageInfoBySchoolId(this.props.root.getMySchoolId());
    }
    else if (option == VIEW_BY_USER) {
      this.getTotalLocaleSizeByUserId(this.state.userList[this.state.userOption]['id']);
      this.getStorageInfoByUserId(this.state.userList[this.state.userOption]['id']);
    }
  }

  refreshSize(option) {
    if (this.props.root.getSameSchoolEdit() <= 0) {
      this.getTotalLocaleSizeByUserId(this.props.root.getMyUserId());
      return;
    }

    if (option == VIEW_BY_SCHOOL) {
      this.getTotalLocaleSizeBySchoolId(this.props.root.getMySchoolId());
    }
    else if (option == VIEW_BY_USER) {
      this.getTotalLocaleSizeByUserId(this.state.userList[this.state.userOption]['id']);
    }
  }

  sortAlphabetDataBy(option) {
    this.setState({ sortBy: option });

    let asc = this.state.sortInAsc;
    let sortedData = this.state.data.sort(function(a, b) {
      if (a[option].toLowerCase() < b[option].toLowerCase()) {
        return (asc ? -1 : 1);
      }
      else if (a[option].toLowerCase() > b[option].toLowerCase()) {
        return (asc ? 1 : -1);
      }
      else {
        if (a['locale_name'] < b['locale_name']) {
          return (asc ? -1 : 1);
        }
        else {
          return (asc ? 1 : -1);
        }
      }
    });

    this.setState({ data: sortedData });
  }

  sortNumericDataBy(option) {
    this.setState({ sortBy: option })

    let asc = this.state.sortInAsc;
    let sortedData = this.state.data.sort(function(a, b) {
      if (a[option] < b[option]) {
        return (asc ? -1 : 1);
      }
      else if (a[option] > b[option]) {
        return (asc ? 1 : -1);
      }
      else {
        if (a['locale_name'] < b['locale_name']) {
          return (asc ? -1 : 1);
        }
        else {
          return (asc ? 1 : -1);
        }
      }
    });

    this.setState({ data: sortedData });
  }

  switchSortOrder() {
    let order = !this.state.sortInAsc;
    this.setState({ sortInAsc: order });
    this.state.sortInAsc = order;
  }

  sortData() {
    if (this.state.sortBy == "locale_name" || this.state.sortBy == "user_display_name") {
      this.sortAlphabetDataBy(this.state.sortBy);
    }
    else if (this.state.sortBy == "is_hidden" || this.state.sortBy == "locale_size" || this.state.sortBy == "ans_size") {
      this.sortNumericDataBy(this.state.sortBy);
    }
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'xl'}
          onEnter={this.handleEnter}
          onClose={this.handleClose}
        >
          <DialogTitle>{Localization.strings.STORAGE_MANAGEMENT}</DialogTitle>
          <DialogContent>
            <If condition={this.props.root.getOriginalUserRole() == 3}>
              <Then>
                <Button onClick={this.cleanAllClicked}>
                  <Icon className="buttonIconLeft">delete</Icon>
                  {Localization.strings.CLEAN_UP_ALL_VITALS}
                </Button>
                <Button onClick={this.cleanHiddenClicked}>
                  <Icon className="buttonIconLeft">delete</Icon>
                  {Localization.strings.CLEAN_UP_HIDDEN_VITALS}
                </Button>
                <Button onClick={this.cleanUnusedClicked}>
                  <Icon className="buttonIconLeft">delete</Icon>
                  {Localization.strings.CLEAN_UP_UNUSED_FILES}
                </Button>
              </Then>
            </If>
            <If condition={this.props.root.getSameSchoolEdit() == 0}>
              <Then>
                <Tabs
                  value={1}
                  onChange={this.handleTabChange}
                  variant="fullWidth"
                  indicatorColor="primary"
                  textColor="primary"
                >
                  <Tab icon={<Icon>face</Icon>} label={Localization.strings.VIEW_BY_USER} value={1} />
                </Tabs>
              </Then>
            </If>
            <If condition={this.props.root.getSameSchoolEdit() == 1}>
              <Then>
                <Tabs
                  value={this.state.viewByOption}
                  onChange={this.handleTabChange}
                  variant="fullWidth"
                  indicatorColor="primary"
                  textColor="primary"
                >
                  <Tab icon={<Icon>school</Icon>} label={Localization.strings.VIEW_BY_SCHOOL} value={0} />
                  <Tab icon={<Icon>face</Icon>} label={Localization.strings.VIEW_BY_USER} value={1} />
                </Tabs>
                <Switch condition={this.state.viewByOption}>
                  <Case value={VIEW_BY_USER}>
                    <UserList parent={this} root={this.props.root}
                      userOption={this.state.userOption}
                      userList={this.state.userList}
                    />
                  </Case>
                </Switch>
              </Then>
            </If>

            <StorageTable parent={this} root={this.props.root} ref="storageTable"
              data={this.state.data}
            />
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button onClick={this.handleClose}>
              {Localization.strings.CLOSE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default StorageViewerDialog;
